import { Injectable } from '@angular/core';
import { ServiceProvider } from './service.provider';
import { DMSBaseService } from './dms.base.service';
import { ItemPagination } from 'app/modules/admin/apps/file-manager/file-manager.types';

@Injectable({ providedIn: 'root' })
export class ActivityService extends DMSBaseService {
  constructor(public provider: ServiceProvider) {
    super("/activities", provider);
  }

  getActivities(docId){
    return this.getList(`/${docId}`)
  }
}